import { shuffleArray } from '@/js/shared/utils/array';
import { makeStyles, Theme } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { getImage, ImageSize } from '../../../shared/utils/imageFormat';
import { ImageRandomPosition } from './image-random-position';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  img: {
    position: 'absolute',
    padding: 8,
    backgroundColor: '#ffffff',
    borderRadius: 2,
    // border: '1px solid #333',
    filter: `drop-shadow(1px 1px 9px rgba(0, 0, 0, 0.3))`,
    '& img': {
      width: '50vw',
      display: 'block',
    },
  },
}));

//   const Transition = forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
//   });

export const DiscussionImageCarousel = ({
  discussionId,
}: {
  discussionId: string;
}) => {
  const classes = useStyles();
  const ref = useRef<HTMLHeadingElement & { parentNode: HTMLHeadingElement }>(
    null
  );
  const [state, setState] = useState<{
    images: string[];
    currentIndex: number;
  }>({ images: [], currentIndex: 0 });

  const [bbox, setBbox] = useState<{ height?: number; width?: number }>({});
  const conferenceId = (window as any).CONFERENCE_ID;
  const set = () =>
    setBbox(
      ref && ref.current && ref.current.parentNode
        ? ref.current.parentNode.getBoundingClientRect()
        : {}
    );

  useEffect(() => {
    set();
    let timeoutId: any = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      timeoutId = setTimeout(set, 300);
    };
    (window as any).addEventListener('resize', resizeListener);
    return () => (window as any).removeEventListener('resize', resizeListener);
  }, []);

  const refreshImages = () => {
    axios
      .get(`/api/visitor/discussions/${discussionId}/images`)
      .then((response) => {
        const newList = shuffleArray([...response.data]);
        setState((currState) => {
          const newImages: string[] = [];
          newList.forEach((img) => {
            if (!currState.images.includes(img)) {
              newImages.push(img);
            }
          });
          // if (currState.images.length === newList.length) {
          return { ...currState, images: newList, currentIndex: -1 };
          // } else {
          //   return {
          //     ...currState,
          //     images: [...currState.images, ...newImages],
          //   };
          // }
        });
        showNextImage();
      });
  };
  const showNextImage = () => {
    setState((currState) => {
      if (currState.images.length < 2) {
        setTimeout(refreshImages, 4000);
        return { ...currState, currentIndex: 0 };
      } else if (
        currState.currentIndex === currState.images.length - 1 &&
        currState.images.length > 1
      ) {
        refreshImages();
        return { ...currState, currentIndex: 0 };
      } else {
        setTimeout(showNextImage, 4000);
        return {
          ...currState,
          currentIndex: (currState.currentIndex + 1) % currState.images.length,
        };
      }
    });
  };

  useEffect(() => {
    // if (
    //   state.images.length === 0 ||
    //   state.currentIndex === state.images.length - 1
    // ) {
    // refreshImages();
    // }
  }, [state.currentIndex === state.images.length - 1]);

  useEffect(() => {
    // showNextImage();
    // const intervalId = setInterval(() => {
    //   showNextImage();
    // }, 4000);
    // return () => clearInterval(intervalId);
    refreshImages();
  }, []);

  const showList = state.images.slice(0, state.currentIndex + 1);

  return (
    <div className={classes.root} ref={ref}>
      {showList.map((img) => (
        <ImageRandomPosition
          key={img}
          src={img}
          containerHeight={bbox.height || 0}
          containerWidth={bbox.width || 0}
          conferenceId={conferenceId}
        />
      ))}
    </div>
  );
};
DiscussionImageCarousel.displayName = 'DiscussionImageCarousel';
